<template>
  <div id="container">
    <van-form @submit="submit">
      <van-field
        v-model="cusUser.express_name"
        label="收货人"
        placeholder="请输入"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="cusUser.express_mobile"
        label="收货电话"
        placeholder="请输入"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="cusUser.express_address"
        label="收货地址"
        placeholder="请输入"
        :rules="[{ required: true }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Api from '@/utils/api'
export default {
  created () {
    Api.post('wei.user/model', null, res => {
      if (res.data.headimgurl === '') res.data.headimgurl = require('@/assets/avatar.png')
      this.weiUser = res.data
      this.cusUser = res.data.cusUser
      this.cusCompany = res.data.cusCompany
    })
  },
  data () {
    return {
      cusUser: {},
      weiUser: {},
      cusCompany: {}
    }
  },
  methods: {
    submit () {
      this.$dialog.confirm({title: '提示', message: '确认修改吗？'})
        .then(() => {
          let params = {
            id: this.cusUser.id,
            express_name: this.cusUser.express_name,
            express_mobile: this.cusUser.express_mobile,
            express_address: this.cusUser.express_address
          }
          Api.post('cus.user/modify', params)
        })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/cus/user/Modify.vue